<template>
<div class="chapter">
<div class="inner_page">
<div class="fm" id="fm">
<p class="nonindent"><a id="page_x"></a><em>Rejoice, young man in your youth, and let your heart pleasure you in the days of your young manhood; and walk in the ways of your heart, and the sight of your eyes; but know that for all these God will bring you into judgment. So remove trouble from your heart and put away wrongdoing from your flesh, for boyhood and youth are a breath</em>.</p>
<p class="right">ECCLESIASTES 11:9–10</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0004.vue?01ec5ed1